"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorFormat = exports.defaultMessagePreview = exports.verboseMessagePreview = exports.enhanceAxiosErrorMessage = void 0;
/**
 * @ignore
 * Since axios error messages are very brief (Request failed with status code 401) and
 * the request failed error does not contain the full trace to the code making the request
 * we append more information.
 *
 * @param err
 */
function enhanceAxiosErrorMessage({ error, messageFormat = ErrorFormat.Verbose }) {
    if (error.config && error.config.method && error.config.url && messageFormat === ErrorFormat.Verbose) {
        // we might need to hide sensitive params here or drop params altogether
        const requestInfo = `${error.config.method.toUpperCase()} ${error.config.url}`;
        error.message = `${error.message} | ${requestInfo}`;
    }
    if (error.response) {
        error.message = messageFormat === ErrorFormat.Verbose
            ? verboseMessagePreview(error)
            : defaultMessagePreview(error);
    }
}
exports.enhanceAxiosErrorMessage = enhanceAxiosErrorMessage;
function verboseMessagePreview(error) {
    const response = error.response;
    let preview = '[no response body]';
    if ((response === null || response === void 0 ? void 0 : response.data) != null) {
        if (typeof response.data === 'object' && !Array.isArray(response.data)) {
            try {
                preview = JSON.stringify(response.data);
            }
            catch (err) {
                preview = '[cyclic object]';
            }
        }
        else {
            // eslint-disable-next-line @typescript-eslint/no-base-to-string
            preview = response.data.toString();
        }
        if (preview.length === 0) {
            preview = '[empty response body]';
        }
        preview = preview.substring(0, 1024);
    }
    return `${error.message} | ${preview}`;
}
exports.verboseMessagePreview = verboseMessagePreview;
function defaultMessagePreview(error) {
    var _a;
    const errorBody = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data;
    if (errorBody != null) {
        if (typeof errorBody === 'string' && errorBody !== '') {
            return errorBody;
        }
        if (typeof errorBody === 'object' && !Array.isArray(errorBody) && errorBody.message != null) {
            return errorBody.message;
        }
    }
    return error.message;
}
exports.defaultMessagePreview = defaultMessagePreview;
var ErrorFormat;
(function (ErrorFormat) {
    ErrorFormat["Normal"] = "normal";
    ErrorFormat["Verbose"] = "verbose";
})(ErrorFormat = exports.ErrorFormat || (exports.ErrorFormat = {}));
